import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createMatchSelector } from 'connected-react-router';
import { actionCreators } from '../common/configuration/configuration.reducer';
import { State } from '../store/root-reducer';
import { isUUID } from '../lib/validator';

const selectSiteMatch = createMatchSelector<State, Match>({
  path: '/site/:mode/:id?',
});

export const useSiteContext = () => {
  const dispatch = useDispatch();
  const match = useSelector(selectSiteMatch);

  const mode = match?.params.mode;
  
  let id: string | undefined;
  
  if (match?.params) {
    if (isUUID(mode)) {
      // Direct site view: /site/{id}
      id = mode;
    } else if (match.params.id && isUUID(match.params.id)) {
      // Site with mode: /site/{mode}/{id}
      id = match.params.id;
    }
  }
  

  React.useEffect(() => {
    // Only fetch data if we have a valid ID
    if (id || mode === 'new' || window.location.pathname === '/sites') {
      dispatch(actionCreators.siteRequest());
      dispatch(actionCreators.clientCompanyRequest());
      dispatch(actionCreators.serverRequest());
      dispatch(actionCreators.wanRequest());
      dispatch(actionCreators.controllerRequest());
      dispatch(actionCreators.linkTypeRequest());
      dispatch(actionCreators.carrierRequest());
    }
  }, [dispatch, id, mode]);

  const sites = useSelector((state: State) => state.configuration.sites);
  const clientCompanies = useSelector((state: State) => state.configuration.clientCompany);
  const servers = useSelector((state: State) => state.configuration.servers);
  const wans = useSelector((state: State) => state.configuration.wans);
  const controllers = useSelector((state: State) => state.configuration.controllers);
  const linkTypes = useSelector((state: State) => state.configuration.linkTypes);
  const carriers = useSelector((state: State) => state.configuration.carriers);

  const isLoading =
    sites.isFetching ||
    clientCompanies.isFetching ||
    servers.isFetching ||
    wans.isFetching ||
    controllers.isFetching ||
    linkTypes.isFetching ||
    carriers.isFetching;

  const isFailed =
    sites.isFailed ||
    clientCompanies.isFailed ||
    servers.isFailed ||
    wans.isFailed ||
    controllers.isFailed ||
    linkTypes.isFailed ||
    carriers.isFailed;

  const isSuccess =
    sites.isSuccess &&
    clientCompanies.isSuccess &&
    servers.isSuccess &&
    wans.isSuccess &&
    controllers.isSuccess &&
    linkTypes.isSuccess &&
    carriers.isSuccess;

  return { id, mode, isLoading, isFailed, isSuccess };
};
